import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useCustomHotkeys } from '../../../../../../common/hooks/useCustomHotkeys';
import { IAnnotationTypeStore } from '../annotationType.store';

export const AnnotationTypeHotKeysContainer = observer((): ReactElement => {
  const annotationTypeStore = useInjection(IAnnotationTypeStore.$);
  const handlers = annotationTypeStore.annotationTypeKeyHandlers;

  const getHandler = (key: string): (() => void) => {
    return handlers.get(key) ?? ((): void => {});
  };

  useCustomHotkeys('`', getHandler('`'), { enabled: handlers.has('`') }, [handlers]);
  useCustomHotkeys('1', getHandler('1'), { enabled: handlers.has('1') }, [handlers]);
  useCustomHotkeys('2', getHandler('2'), { enabled: handlers.has('2') }, [handlers]);
  useCustomHotkeys('3', getHandler('3'), { enabled: handlers.has('3') }, [handlers]);
  useCustomHotkeys('4', getHandler('4'), { enabled: handlers.has('4') }, [handlers]);
  useCustomHotkeys('5', getHandler('5'), { enabled: handlers.has('5') }, [handlers]);
  useCustomHotkeys('6', getHandler('6'), { enabled: handlers.has('6') }, [handlers]);
  useCustomHotkeys('7', getHandler('7'), { enabled: handlers.has('7') }, [handlers]);
  useCustomHotkeys('8', getHandler('8'), { enabled: handlers.has('8') }, [handlers]);
  useCustomHotkeys('9', getHandler('9'), { enabled: handlers.has('9') }, [handlers]);
  useCustomHotkeys('9', getHandler('0'), { enabled: handlers.has('0') }, [handlers]);

  return <></>;
});
